//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export enum STREAM_CREATION_ACTIONS {
  ADD_SELECTED_SOURCE = 'STREAM_EDITOR/ADD_SELECTED_SOURCE',
  CHANGE_STREAM_NAME = 'STREAM_EDITOR/CHANGE_STREAM_NAME',
  CHANGE_SOURCE_TYPE = 'STREAM_EDITOR/CHANGE_SOURCE_TYPE',
  CHANGE_EXCLUSION_SOURCE_TYPE = 'STREAM_EDITOR/CHANGE_EXCLUSION_SOURCE_TYPE',
  CHANGE_SOURCE_VALUE = 'STREAM_EDITOR/CHANGE_SOURCE_VALUE',
  CLEAR_STATE = 'STREAM_EDITOR/CLEAR_STATE',
  REMOVE_SELECTED_SOURCE = 'STREAMS/REMOVE_SELECTED_SOURCE',
  SET_EXISTING_STREAM = 'STREAM_EDITOR/SET_EXISTING_STREAM',
  SET_IS_LOADING_SOURCES = 'STREAM_EDITOR/SET_IS_LOADING_SOURCES',
  SET_OUTSTANDING_SAVE_REQUEST = 'STREAM_EDITOR/SET_OUTSTANDING_SAVE_REQUEST',
  SET_SELECTED_SOURCES = 'STREAM_EDITOR/SET_SELECTED_SOURCES',
  ADD_EXCLUSION_SOURCE = 'STREAM_EDITOR/ADD_EXCLUSION_SOURCE',
  REMOVE_EXCLUSION_SOURCE = 'STREAM_EDITOR/REMOVE_EXCLUSION_SOURCE',
  CHANGE_EXCLUSION_SOURCE_VALUE = 'STREAM_EDITOR/CHANGE_EXCLUSION_SOURCE_VALUE',
  SET_SELECTED_EXCLUDED_SOURCES = 'STREAM_EDITOR/SET_SELECTED_EXCLUDED_SOURCES',

  SET_EXCLUSION_SOURCE_ERROR = 'STREAMS/SET_EXCLUSION_SOURCE_ERROR',
  SET_EXCLUSION_SOURCE_TYPE_ERROR = 'STREAM_EDITOR/SET_EXCLUSION_SOURCE_TYPE_ERROR',
  SET_CREATE_STREAM_ERROR = 'STREAM_EDITOR/SET_CREATE_STREAM_ERROR',
  SET_SOURCE_ERROR = 'STREAM_EDITOR/SET_SOURCE_ERROR',
  SET_SOURCE_TYPE_ERROR = 'STREAM_EDITOR/SET_SOURCE_TYPE_ERROR',
  SET_STREAM_NAME_ERROR = 'STREAM_EDITOR/SET_STREAM_NAME_ERROR',
}
